module.exports = __webpack_public_path__ + "static/media/alert_error.1dbeca9c.svg";